import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import services from "../services";
import withMessage from "./withMessage";
import withResponseHandling from "./withResponseHandling";
const PAGE_SIZE = 25;
const withRegras = (Component, state = {}) => {
  function WrapComponent(props) {
    const reportsUpdatedAt = useSelector(state => state.background.reports.updatedAt);
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const {
      output,
      id
    } = useParams();
    const [regras, setRegras] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });
    const [columnFilters, setColumnFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    function formatColumnFilters(pColumnFilters = []) {
      const xFilters = {};
      pColumnFilters.forEach(xItem => {
        xFilters[xItem.id] = xItem.value;
      });
      return xFilters;
    }
    const readRegras = useCallback((pParams = {}) => {
      if (!regras.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }
      const xParams = {
        size: PAGE_SIZE,
        page: 1,
        ...pParams,
        sort: "descricao ASC"
      };
      services.enquadramentosRegras.list(xParams, rRes => {
        setRegras(Object.values(rRes.data));
        setRowCount(rRes.pages.total_items);
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {
        setIsLoading(false);
        setIsRefetching(false);
      });
    }, [regras.length, output, props]);
    const deleteRegras = (pParams, onFinish) => {
      services.enquadramentosRegras.remove(pParams, rRes => {
        props.onMessageSuccess("Enquadramento excluído com sucesso");
        readRegras({
          enquadramento_id: pParams.enquadramento_id
        });
        setRowSelection({});
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {
        onFinish && onFinish();
      });
    };
    const bulkDeleteRegras = pRows => {
      const xRegras = pRows.map(xRow => {
        const {
          enquadramento_id,
          enquadramento_regra_id
        } = xRow.original;
        return {
          enquadramento_id,
          enquadramento_regra_id
        };
      });
      xRegras.forEach(xParams => {
        deleteRegras(xParams);
      });
    };
    useEffect(() => {
      const xPage = pagination.pageIndex + 1;

      //const xSort = formatSorting(sorting);

      const xFilters = formatColumnFilters(columnFilters);
      id && readRegras({
        page: xPage,
        size: pagination.pageSize,
        enquadramento_id: id,
        ...xFilters
        //sort: xSort,
      });
    }, [readRegras, pagination.pageIndex, pagination.pageSize, reportsUpdatedAt, entidadeId, columnFilters, sorting, globalFilter, id]);
    const xProps = {
      regras,
      isLoading,
      isRefetching,
      rowCount,
      pagination,
      sorting,
      columnFilters,
      rowSelection,
      setPagination,
      setRowSelection,
      setColumnFilters,
      setSorting,
      setGlobalFilter,
      readRegras,
      deleteRegras,
      bulkDeleteRegras
    };
    return <Component {...xProps} />;
  }
  return withMessage(withResponseHandling(WrapComponent));
};
export default withRegras;
